import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ScrollToTop: zaručí posun na začátek stránky při změně cesty
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    // Ensure browser doesn't restore previous scroll position automatically
    try {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
    } catch (_) {}

    // Temporarily force instant scroll behavior to avoid CSS smooth interfering
    const root = document.documentElement;
    const prevBehavior = root && root.style ? root.style.scrollBehavior : undefined;
    if (root && root.style) {
      root.style.scrollBehavior = 'auto';
    }

    // Snažíme se scrollovat před vykreslením obsahu a několikrát po
    const doScrollTop = () => {
      // Vícenásobné pokusy pro jistotu
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    // Okamžitě
    doScrollTop();
    
    // V requestAnimationFrame (před vykreslením)
    const rafId = requestAnimationFrame(() => doScrollTop());
    
    // Po krátkých intervalech (pro případ pomalého vykreslování)
    const t1 = setTimeout(doScrollTop, 0);
    const t2 = setTimeout(doScrollTop, 10);
    const t3 = setTimeout(doScrollTop, 50);
    const t4 = setTimeout(doScrollTop, 100);

    // Restore previous scroll-behavior after scroll settles
    const restoreTimer = setTimeout(() => {
      if (root && root.style) {
        if (prevBehavior) root.style.scrollBehavior = prevBehavior; else root.style.removeProperty('scroll-behavior');
      }
    }, 180);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(t4);
      clearTimeout(restoreTimer);
    };
  }, [pathname, search]);

  return null;
}
